"use client";
import FeaturesSection from "~/components/_pages/home/features";
import { GetStartedSection } from "~/components/_pages/home/get_started";
import HeroSection from "~/components/_pages/home/hero";
import ModelsSection from "~/components/_pages/home/models";
import PlansSection from "~/components/_pages/home/plans";
import TestimonialsSection from "~/components/_pages/home/testimonials";
import WhyFigAiSection from "~/components/_pages/home/why_figai";

export default function Consume() {
  return (
    <>
      <HeroSection />
      <ModelsSection />
      <WhyFigAiSection />
      {/* <LearnMoreSection /> */}
      <FeaturesSection />
      <PlansSection />
      <TestimonialsSection />
      <GetStartedSection />
    </>
  );
}
